var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SiteLayoutFoundationsPsalter',[_c('HymnalHymnInfo',{attrs:{"hymn":_vm.psalm,"check-psalter":"","foundations":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }